// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__RODRF","boxTitle":"Qualiphy_boxTitle__2QRvV","box":"Qualiphy_box__32mFd","toggleWrap":"Qualiphy_toggleWrap__3QB3A"};